var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    {
      staticClass: "actions",
      style: {},
      attrs: { x: "", y: false, tag: "w-row" },
    },
    [
      _vm.state.showViewSelect()
        ? _c("app-select-view", { attrs: { state: _vm.state } })
        : _vm._e(),
      _c(
        "w-button-bar",
        { style: { flexShrink: 0 } },
        [
          _c(
            "w-button",
            {
              attrs: { disabled: _vm.isFetching },
              on: {
                click: function ($event) {
                  return _vm.refresh()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "sync", spin: _vm.isFetching } })],
            1
          ),
        ],
        1
      ),
      !_vm.$wf.isMdDown
        ? _c("app-quick-search", {
            attrs: { state: _vm.state },
            on: {
              enter: function ($event) {
                return _vm.startSearch($event)
              },
            },
          })
        : _vm._e(),
      _vm._t("top"),
      _c("w-spacer", { staticClass: "mr" }),
      _vm.itemsSelected
        ? _c(
            "app-tag",
            {
              staticClass: "mr action",
              attrs: { icon: "times" },
              on: {
                click: function ($event) {
                  return _vm.emptySelectedItems()
                },
              },
            },
            [
              !_vm.$wf.isLgDown
                ? [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$ctc("selected", _vm.selectedItems.length, {
                            amount: _vm.selectedItems.length,
                          })
                        ) +
                        " "
                    ),
                  ]
                : [_vm._v(" " + _vm._s(_vm.selectedItems.length) + " ")],
            ],
            2
          )
        : _vm._e(),
      _vm.querySettings.searchQuery
        ? _c(
            "app-tag",
            {
              staticClass: "mr action search-chip",
              attrs: { icon: "times" },
              on: {
                click: function ($event) {
                  return _vm.clearSearchQuery()
                },
              },
            },
            [
              !_vm.$wf.isLgDown
                ? [
                    _c("span", { staticClass: "search-chip-content" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$ct("cancelSearch", [_vm.displayedSearchVal])
                          ) +
                          " "
                      ),
                    ]),
                  ]
                : [
                    _c("w-fa", { attrs: { icon: "search" } }),
                    _vm._v(' " '),
                    _c("span", { staticClass: "search-chip-content" }, [
                      _vm._v(" " + _vm._s(_vm.displayedSearchVal) + " "),
                    ]),
                    _vm._v(' " '),
                  ],
            ],
            2
          )
        : _vm._e(),
      _vm.querySettings.filters.length && !_vm.querySettings.searchQuery
        ? _c(
            "app-tag",
            {
              staticClass: "light mr tag action",
              attrs: { icon: "times" },
              on: {
                click: function ($event) {
                  return _vm.clearFilters()
                },
              },
            },
            [
              !_vm.$wf.isMdDown
                ? [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$ct("cancelFilters", [
                            _vm.querySettings.filters.length,
                          ])
                        ) +
                        " "
                    ),
                  ]
                : [
                    _c("w-fa", { attrs: { icon: "search" } }),
                    _vm._v(
                      " " + _vm._s(_vm.querySettings.filters.length) + " "
                    ),
                  ],
            ],
            2
          )
        : _vm._e(),
      _vm.editButtonBarVisible
        ? _c(
            "w-button-bar",
            { style: { flexShrink: 0 } },
            [
              _vm._l(_vm.customButtonsStart, function (btn, index) {
                return _c(
                  "w-button",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: btn.Name,
                        expression: "btn.Name",
                      },
                    ],
                    key: "custom-btn-start-" + index,
                    attrs: {
                      disabled: btn.isDisabledForSelection(
                        _vm.selectedItems.length
                      ),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.state.openCustomButton(btn)
                      },
                    },
                  },
                  [
                    _c("w-fa", {
                      attrs: { icon: btn.Icon || "external-link-alt" },
                    }),
                  ],
                  1
                )
              }),
              !_vm.isButtonHidden("add")
                ? _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("custom-tooltip.add", {
                            browse: _vm.browseName,
                          }),
                          expression:
                            "$ct('custom-tooltip.add',{'browse':browseName})",
                        },
                      ],
                      attrs: { to: _vm.addRoute, disabled: _vm.addDisabled },
                    },
                    [_c("w-fa", { attrs: { icon: "plus" } })],
                    1
                  )
                : _vm._e(),
              !_vm.isButtonHidden("edit")
                ? _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("custom-tooltip.edit", {
                            browse: _vm.browseName,
                          }),
                          expression:
                            "$ct('custom-tooltip.edit',{'browse':browseName})",
                        },
                      ],
                      attrs: { disabled: _vm.editDisabled },
                      on: {
                        click: function ($event) {
                          return _vm.editClicked()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "pencil-alt" } })],
                    1
                  )
                : _vm._e(),
              _vm.dataSource.duplicate && !_vm.isButtonHidden("duplicate")
                ? _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("custom-tooltip.duplicate", {
                            browse: _vm.browseName,
                          }),
                          expression:
                            "$ct('custom-tooltip.duplicate',{'browse':browseName})",
                        },
                      ],
                      attrs: { disabled: _vm.duplicateDisabled },
                      on: {
                        click: function ($event) {
                          return _vm.duplicateClicked()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "clone" } })],
                    1
                  )
                : _vm._e(),
              !_vm.isButtonHidden("delete")
                ? _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("custom-tooltip.remove", {
                            browse: _vm.browseName,
                          }),
                          expression:
                            "$ct('custom-tooltip.remove',{'browse':browseName})",
                        },
                      ],
                      attrs: { disabled: _vm.deleteDisabled },
                      on: {
                        click: function ($event) {
                          return _vm.deleteClicked()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "minus" } })],
                    1
                  )
                : _vm._e(),
              _vm.dataSource.info && !_vm.isButtonHidden("info")
                ? _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("custom-tooltip.info", {
                            browse: _vm.browseName,
                          }),
                          expression:
                            "$ct('custom-tooltip.info',{'browse':browseName})",
                        },
                      ],
                      attrs: { disabled: !_vm.canView },
                      on: {
                        click: function ($event) {
                          return _vm.infoClicked()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "eye" } })],
                    1
                  )
                : _vm._e(),
              _vm._l(_vm.customButtonsEnd, function (btn, index) {
                return _c(
                  "w-button",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: btn.Name,
                        expression: "btn.Name",
                      },
                    ],
                    key: "custom-btn-end-" + index,
                    attrs: {
                      disabled: btn.isDisabledForSelection(
                        _vm.selectedItems.length
                      ),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.state.openCustomButton(btn)
                      },
                    },
                  },
                  [
                    _c("w-fa", {
                      attrs: { icon: btn.Icon || "external-link-alt" },
                    }),
                  ],
                  1
                )
              }),
              _vm.state.sidebar.Enabled
                ? _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct(
                            _vm.state.sidebarOpen
                              ? "sidebar.hide"
                              : "sidebar.show"
                          ),
                          expression:
                            "$ct(state.sidebarOpen ? 'sidebar.hide' : 'sidebar.show')",
                        },
                      ],
                      class: { "sidebar-active": _vm.state.sidebarOpen },
                      on: {
                        click: function ($event) {
                          return _vm.state.toggleSidebar()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "info-circle" } })],
                    1
                  )
                : _vm._e(),
              _vm.$wf.isMdDown
                ? _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("tooltip.search"),
                          expression: "$ct('tooltip.search')",
                        },
                      ],
                      on: {
                        click: function ($event) {
                          _vm.state.showSearch = true
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "search" } })],
                    1
                  )
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm.state.activeCustomButton
        ? _c("app-custom-button-modal", {
            attrs: {
              button: _vm.state.activeCustomButton,
              model: _vm.state.customButtonModel,
            },
            model: {
              value: _vm.state.showCustomButtonModal,
              callback: function ($$v) {
                _vm.$set(_vm.state, "showCustomButtonModal", $$v)
              },
              expression: "state.showCustomButtonModal",
            },
          })
        : _vm._e(),
      _c(
        "w-button-bar",
        { style: { flexShrink: 0 } },
        [
          !_vm.$wf.isMdDown
            ? _c(
                "w-button",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: _vm.$ct("tooltip.search"),
                      expression: "$ct('tooltip.search')",
                    },
                  ],
                  on: {
                    click: function ($event) {
                      _vm.state.showSearch = true
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "search" } })],
                1
              )
            : _vm._e(),
          !_vm.$wf.isMdDown ? _vm._t("extra-buttons") : _vm._e(),
          !_vm.controlsDisabled
            ? [
                !_vm.$wf.isMdDown
                  ? _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("print-browse"),
                            expression: "$ct('print-browse')",
                          },
                        ],
                        style: { paddingRight: "10px" },
                        on: {
                          click: function ($event) {
                            _vm.state.browseToFileModalOpen = true
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "print" } })],
                      1
                    )
                  : _vm._e(),
                !_vm.$wf.isMdDown
                  ? _c("app-reports-dropdown", {
                      attrs: {
                        state: _vm.state,
                        "with-printing-button": false,
                      },
                    })
                  : _vm._e(),
                _vm.buttonBarItems != undefined
                  ? _c(
                      "w-dropdown",
                      {
                        attrs: {
                          items: _vm.buttonBarItems,
                          disabled:
                            _vm.buttonBarItems &&
                            _vm.buttonBarItems.length == 0,
                          right: "",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.trigger($event)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "bars" } })],
                      1
                    )
                  : _vm._e(),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._t("browse-action-buttons"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }